import { Box, type BoxProps, SxProps, Theme } from '@mui/material';

import mixinSx from '@watershed/style/mixinSx';

const FILLS: Record<string, SxProps<Theme>> = {
  blue: { fill: (theme: Theme) => theme.palette.cobalt },
  periwinkle: { fill: (theme: Theme) => theme.palette.cobalt40 },
  white: { fill: (theme: Theme) => theme.palette.white },
  newDay: { fill: (theme: Theme) => theme.palette.newDay },
  semiTransparent: { fill: (theme: Theme) => theme.palette.lightShadow },
  grey40: { fill: (theme: Theme) => theme.palette.grey40 },
};

function Logo({
  size = 24,
  color = 'blue',
  sx,
  ...props
}: {
  size?: number | string;
  color?: keyof typeof FILLS;
  sx?: SxProps<Theme>;
} & BoxProps) {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      sx={mixinSx(sx, FILLS[color])}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* eslint-disable-next-line @watershed/literals-must-be-i18n-ready */}
      <title>Watershed logo</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.12923 11.0646C2.10041 11.3725 2.08568 11.6845 2.08568 12C2.08568 15.9297 4.37233 19.3256 7.68794 20.9295C7.55134 20.6992 7.42257 20.4616 7.3018 20.2186C6.23231 18.0671 5.60076 15.1678 5.60076 12.0222C5.60076 11.0297 5.66365 10.0616 5.78333 9.13385C4.88256 9.10597 4.27846 9.28635 3.84463 9.51132C3.27256 9.80798 2.9204 10.1971 2.496 10.666C2.38099 10.7931 2.26067 10.926 2.12923 11.0646ZM3.14709 7.53238C3.96178 7.16682 4.9412 6.98202 6.15928 7.06436C6.44395 5.86819 6.83032 4.77437 7.3018 3.82587C7.43352 3.56086 7.57476 3.3022 7.7253 3.05254C5.7487 3.99846 4.13442 5.57999 3.14709 7.53238ZM10.9572 2.50311C10.3558 2.897 9.7331 3.62059 9.16936 4.75471C8.79087 5.51614 8.46793 6.41302 8.22099 7.41264C9.34239 7.71552 10.2279 8.2159 10.9572 8.81593L10.9572 2.50311ZM10.9572 11.8897C10.1472 10.7729 9.26171 9.9025 7.84251 9.47399C7.74105 10.2847 7.68644 11.1383 7.68644 12.0222C7.68644 14.9157 8.27163 17.4838 9.16936 19.2898C9.73309 20.4239 10.3558 21.1475 10.9572 21.5414L10.9572 11.8897ZM13.0428 21.6376L13.0428 14.9517C13.7391 15.838 14.598 16.6743 15.7741 17.2385C15.554 17.9966 15.2888 18.6858 14.9885 19.2898C14.3753 20.5235 13.6922 21.2714 13.0428 21.6376ZM16.2385 15.1199C15.1184 14.4297 14.4075 13.3323 13.541 11.9948C13.4723 11.8887 13.4027 11.7812 13.3317 11.6722C13.2376 11.5276 13.1416 11.3814 13.0429 11.2344L13.0429 2.40693C13.6923 2.7731 14.3753 3.52102 14.9885 4.75471C15.8863 6.56072 16.4715 9.12875 16.4715 12.0222C16.4715 13.1083 16.389 14.1486 16.2385 15.1199ZM18.2276 15.8734C18.4423 14.6604 18.5571 13.3637 18.5571 12.0222C18.5571 8.8767 17.9256 5.97742 16.8561 3.82587C16.7437 3.59975 16.6244 3.37824 16.4983 3.16301C19.713 4.80246 21.9143 8.1443 21.9143 12C21.9143 12.7784 21.8246 13.5359 21.6549 14.2626C21.6269 14.2556 21.627 14.2554 21.627 14.2552L21.6273 14.254L21.6278 14.2519L21.6287 14.2487L21.6293 14.246C21.6294 14.246 21.6285 14.2492 21.6267 14.2555C21.623 14.268 21.6156 14.2924 21.6038 14.3264C21.5801 14.3948 21.5396 14.4992 21.4779 14.6228C21.3525 14.8742 21.1531 15.1784 20.8535 15.4319C20.439 15.7825 19.6673 16.1757 18.2276 15.8734ZM17.7527 17.9036C17.5044 18.7427 17.2033 19.5201 16.8561 20.2186C16.7547 20.4226 16.6477 20.6228 16.5351 20.8181C17.8447 20.1433 18.9846 19.1853 19.8738 18.0252C19.2491 18.1033 18.5439 18.0738 17.7527 17.9036ZM12.1831 23.9986C18.7258 23.9008 24 18.5666 24 12C24 5.37228 18.6271 0 12 0C5.37289 0 0 5.37228 0 12C0 18.6277 5.37289 24 12 24C12.0165 24 12.0331 24 12.0496 23.9999C12.0593 24 12.0691 24 12.0789 24C12.1138 24 12.1485 23.9995 12.1831 23.9986Z"
      />
    </Box>
  );
}

export default Logo;
